import * as Yup from 'yup';
import { EMAIL_REG_EX, PHONE_REG_EX } from '../utils/regex';
import {
  INSTANCE_PHONE_REG_EX,
  INSTANCE_PHONE_MIN_LENGTH,
} from '../utils/instanceConstant';
export const getPartnerDetailsInitialValues = (partner) => {
  return {
    description: partner && partner.description ? partner.description : '',
    // TAK-2086: an In-kind partner's fixed value on the activity
    inKindValue:
      partner && partner.supportType === 'IN_KIND' && partner.cost
        ? String(Number(partner.cost))
        : '',

    firstName: partner && partner.firstName ? partner.firstName : '',
    email: partner && partner.email ? partner.email : '',
    secondName: partner && partner.secondName ? partner.secondName : '',
    entityName: partner && partner.entityName ? partner.entityName : '',
    streetAddress:
      partner && partner.streetAddress ? partner.streetAddress : '',
    streetAddress2:
      partner && partner.streetAddress2 ? partner.streetAddress2 : '',
    suburb: partner && partner.suburb ? partner.suburb : '',
    state: partner && partner.state ? partner.state : '',
    postCode: partner && partner.postCode ? partner.postCode : '',
    phone: partner && partner.phone ? partner.phone : '',
    abn: partner && partner.abn ? partner.abn : '',
    acn: partner && partner.acn ? partner.acn : '',
    organisationName:
      partner && partner.organisationName ? partner.organisationName : '',
  };
};

export const partnerDetailsExternalValidationSchema = (t, isFromActivity) => {
  let validationSchema = {
    firstName: Yup.string().optional(),
    secondName: Yup.string().optional(),
    email: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(EMAIL_REG_EX, t('formulary.validation.email_not_valid')),
    phone: Yup.string()
      .required(t('formulary.validation.phone_number_required'))
      .matches(
        INSTANCE_PHONE_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      )
      .min(
        INSTANCE_PHONE_MIN_LENGTH,
        t('formulary.validation.must_be_a_minimum_of_digits', {
          count: INSTANCE_PHONE_MIN_LENGTH,
        })
      )
      .optional(),
    entityName: Yup.string().optional(),
    streetAddress: Yup.string().optional(),
    streetAddress2: Yup.string().optional(),
    suburb: Yup.string().optional(),
    state: Yup.string().optional(),
    postcode: Yup.string().optional(),
    supportType: Yup.string().oneOf(['IN_KIND', 'FUNDING', 'NETWORK']),
    description: Yup.string().optional(),
  };

  return Yup.object().shape(validationSchema);
};

export const partnerDetailsGuestValidationSchema = (t, isFromActivity) => {
  let validationSchema = {
    firstName: Yup.string().required(
      t('formulary.validation.first_name_required')
    ),
    secondName: Yup.string().required(
      t('formulary.validation.second_name_required')
    ),
    email: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(EMAIL_REG_EX, t('formulary.validation.email_not_valid')),
    phone: Yup.string()
      .required(t('formulary.validation.phone_number_required'))
      .matches(
        INSTANCE_PHONE_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      )
      .min(
        INSTANCE_PHONE_MIN_LENGTH,
        t('formulary.validation.must_be_a_minimum_of_digits', {
          count: INSTANCE_PHONE_MIN_LENGTH,
        })
      )
      .optional(),
    entityName: Yup.string().optional(),
    organisationName: Yup.string().optional(),
    address: Yup.string().optional(),
    address2: Yup.string().optional(),
    suburb: Yup.string().optional(),
    state: Yup.string().optional(),
    postcode: Yup.string().optional(),
    description: Yup.string().optional(),
  };

  return Yup.object().shape(validationSchema);
};

export const partnerDetailsAnonymousValidationSchema = Yup.object().shape({
  supportType: Yup.string().oneOf(['IN_KIND', 'FUNDING', 'NETWORK']),
  description: Yup.string().optional(),
});
